import React from 'react';
import PropTypes from 'prop-types';
import css from './Modal.module.scss';

const ModalActions = ({children, className, align = 'right'}) => {
  const alignmentClass = align === 'right' ? css.alignRight :
                        align === 'center' ? css.alignCenter : 
                        css.alignLeft;

  return (
    <div className={`${css.modalActions} ${alignmentClass} ${className || ''}`}>
      {children}
    </div>
  );
};

ModalActions.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  align: PropTypes.oneOf(['left', 'center', 'right'])
};

export default ModalActions;
